/* global rwgps */
import React from 'react'
import styles from './Postcard.scss'
import cx from 'classnames'
import _ from 'lodash'

// Wrapper around rwgps.postcards. Read-only: after the postcard has been
// initialized, changing layout or srcs will do nothing. To change an aspect
// of the Postcard programatically, force a remount by changing the component
// key
export class Postcard extends React.Component {
  constructor (props) {
    super(props)
    if (props.srcs && props.layout) {
      throw TypeError('Only one of srcs or layout can be specified on a Postcard.')
    }
    if (!props.srcs && !props.layout) {
      throw TypeError('You must specify at least one of srcs or layout on a Postcard.')
    }
    this._containerId = Math.random().toString(36).slice(2)
    this.debouncedResize = _.debounce(this.onResize, 400)
  }

  componentDidMount () {
    this.initPostcard()
    window.addEventListener('resize', this.debouncedResize)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.debouncedResize)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return !(_.isEqual(this.props, nextProps))
  }

  initPostcard = () => {
    const {srcs, layout, edit, clickableImages, disableFilmstrip} = this.props
    const options = {
      srcs,
      layout,
      edit,
      disableFilmstrip,
      clickableImages: !!clickableImages,
      onImageMoveComplete: this.onPostcardChanged,
      onImageScaleComplete: this.onPostcardChanged
    }

    this._postcard = new rwgps.postcards.Postcard('#' + this._containerId, options)
    this._postcard.on('image:click', this.onImageClick)
  }

  onPostcardChanged = () => {
    if (this.props.onChange) {
      const layout = this._postcard.serializeLayout()
      this.props.onChange(layout)
    }
  }

  onResize = () => {
    this._postcard.renderIfSizeChanged()
  }

  onImageClick = (image) => {
    this.props.onImageClick && this.props.onImageClick(image)
  }

  render () {
    const {onClick} = this.props
    return (
      <div className={styles.Postcard} id={this._containerId} onClick={onClick}>
        <div className={cx('postcard', styles.postcardDiv)} >
          <div className={cx('imagecells', styles.imagecells)} />
        </div>
      </div>
    )
  }
}
